import { AxnCacheState } from "@idw-types/state/axn-cache-state";
import { AxnCacheActionTypes, AxnCacheActions } from "../actions/axn-cache-actions";

export const initialAxnCacheState: AxnCacheState = {
    isRefreshing: false,
    lastRefreshDate: null,
    refreshResults: null
};

export const axnCacheReducer = (
    state: AxnCacheState = initialAxnCacheState,
    action: AxnCacheActions
): AxnCacheState => {
    switch(action.type) {
        case AxnCacheActionTypes.SET_AXN_CACHE_REFRESHING:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing
            };
        case AxnCacheActionTypes.SET_AXN_CACHE_REFRESH_RESULTS:
            return {
                ...state,
                isRefreshing: false,
                refreshResults: action.payload.refreshResults,
                lastRefreshDate: action.payload.lastRefreshDate,
            };
        default:
            return state;
    }
};